module.exports = __webpack_public_path__ + "img/slide6.30e510e2.jpeg";